// extracted by mini-css-extract-plugin
export var header = "_6v-0";